import * as types from './action-types'

function handleErrors(res) {
  if (!res.ok) throw Error(res.statusText)
  return res
}

const requestArtistCaseStudy = id => ({
  type: types.REQUEST_ARTIST_CASE_STUDY,
  payload: id
})

const receiveArtistCaseStudy = data => ({
  type: types.RECEIVE_ARTIST_CASE_STUDY,
  payload: {
    data,
    receivedAt: Date.now()
  }
})

const errorArtistCaseStudy = () => ({
  type: types.ERROR_ARTIST_CASE_STUDY
})

export const fetchArtistCaseStudy = id => dispatch => {
  dispatch(requestArtistCaseStudy(id));

  return fetch(`/api/artists/${id}`)
    .then(handleErrors)
    .then(res => res.json())
    .then(json => dispatch(receiveArtistCaseStudy(json)))
    .catch(e => dispatch(errorArtistCaseStudy(e)))
}



// WEBPACK FOOTER //
// ./src/components/artist-case-studies-container/actions.js